// Scoring types + anomaly helper.

import type { Dimension } from './dimensions';

export interface DimensionScore {
  dimension: Dimension;
  score: number; // 0..100
  confidence: number; // 0..1
  confidence_band_low: number;
  confidence_band_high: number;
  signal_count: number;
  status: 'scored' | 'pending' | 'learning';
}

export const COMPOSITE_CONFIDENCE_FLOOR = 0.3;

// 2σ above historical movement = anomaly.
export function isAnomalousMovement(
  historicalDeltas: number[],
  latestDelta: number
): { anomalous: boolean; sigma: number } {
  if (historicalDeltas.length < 4) {
    // Not enough history to call anomaly.
    return { anomalous: false, sigma: 0 };
  }
  const mean = historicalDeltas.reduce((a, b) => a + b, 0) / historicalDeltas.length;
  const variance =
    historicalDeltas.reduce((a, b) => a + (b - mean) ** 2, 0) / historicalDeltas.length;
  const stdev = Math.sqrt(variance);
  if (stdev === 0) {
    return { anomalous: Math.abs(latestDelta - mean) > 0.01, sigma: Infinity };
  }
  const sigma = (latestDelta - mean) / stdev;
  return { anomalous: Math.abs(sigma) >= 2, sigma };
}
